import { connect } from 'react-redux';
import { makeValueSelector } from '../../selectors.js';
import ContentPreview from './content-preview.jsx';

const getMapStateToProps = () => {
  const selector = makeValueSelector();
  return (state, props) => selector(state, props);
};

export default connect(getMapStateToProps)(ContentPreview);
